// Japan's home-page area photos. AVIF/WebP are 260 px wide (tiles render at most 129 CSS px),
// cwebp -q 74 / avifenc -q 52 as in scripts/generate_responsive_images.cjs. The 480 px JPG is the fallback.
import type { ResponsiveImage, ImageCredit } from '@/site/fallback/data/homeImages';
import hokkaidoJpg from '@/assets/area-hokkaido.jpg';
import hokkaidoWebp from '@/assets/area-hokkaido.webp';
import hokkaidoAvif from '@/assets/area-hokkaido.avif';
import tohokuJpg from '@/assets/area-tohoku.jpg';
import tohokuWebp from '@/assets/area-tohoku.webp';
import tohokuAvif from '@/assets/area-tohoku.avif';
import niigataJpg from '@/assets/area-niigata.jpg';
import niigataWebp from '@/assets/area-niigata.webp';
import niigataAvif from '@/assets/area-niigata.avif';
import naganoJpg from '@/assets/area-nagano.jpg';
import naganoWebp from '@/assets/area-nagano.webp';
import naganoAvif from '@/assets/area-nagano.avif';
import kantoJpg from '@/assets/area-kanto.jpg';
import kantoWebp from '@/assets/area-kanto.webp';
import kantoAvif from '@/assets/area-kanto.avif';
import centralJpg from '@/assets/area-central.jpg';
import centralWebp from '@/assets/area-central.webp';
import centralAvif from '@/assets/area-central.avif';
import westJpg from '@/assets/area-west.jpg';
import westWebp from '@/assets/area-west.webp';
import westAvif from '@/assets/area-west.avif';

export const AREA_IMAGES: Record<string, ResponsiveImage> = {
  hokkaido: { jpg: hokkaidoJpg, webp: hokkaidoWebp, avif: hokkaidoAvif },
  tohoku: { jpg: tohokuJpg, webp: tohokuWebp, avif: tohokuAvif },
  niigata: { jpg: niigataJpg, webp: niigataWebp, avif: niigataAvif },
  nagano: { jpg: naganoJpg, webp: naganoWebp, avif: naganoAvif },
  kanto: { jpg: kantoJpg, webp: kantoWebp, avif: kantoAvif },
  central: { jpg: centralJpg, webp: centralWebp, avif: centralAvif },
  west: { jpg: westJpg, webp: westWebp, avif: westAvif },
};

export const RESORT_PHOTOS: Record<string, ResponsiveImage> = {};

export const IMAGE_CREDITS: ImageCredit[] = [];
